import { render } from "./SummaryPerson.vue?vue&type=template&id=e1d4b99a&ts=true"
import script from "./SummaryPerson.vue?vue&type=script&lang=ts"
export * from "./SummaryPerson.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/weleaf/twd-origination-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QTable,QTr,QTh});
